import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ModalDialogType, ReturnPaymentType } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { Order } from 'src/app/models/order';
import { InvoiceRequestModel } from 'src/app/models/request/InvoiceRequestModel';
import { ReturnTransactionRequest } from 'src/app/models/request/return-transaction-request';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { OrderService } from 'src/app/services/order.service';
import { ParamsService } from 'src/app/services/params.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-return-invoice-stepper',
  templateUrl: './create-return-invoice-stepper.component.html',
  styleUrls: ['./create-return-invoice-stepper.component.sass']
})
export class CreateReturnInvoiceStepperComponent implements OnInit {

  order: Order = new Order();
  constructor(private route: ActivatedRoute, private orderSerivce: OrderService, private configService: ConfigurationService,
    private confirmService: PosConfirmationService,
    private paramsService: ParamsService,
    private invoiceService: InvoiceService,
    private toastr: ToastrService,
    private router: Router,
    private readonly exceptionSolutionService: ExceptionSolutionService) { }

  async ngOnInit(): Promise<void> {
    let orderComplete = (await this.orderSerivce.readerOrderCompleteProcess(this.route.snapshot.params.code).toPromise()).response;
    this.order = orderComplete.order
  }

  async return(type: ReturnPaymentType) {
    const returnMaxCash = (await this.paramsService.readParam("returns-max-cash").toPromise()).response;

    if (this.order.totals.netTotal >= Number(returnMaxCash.value) && type == ReturnPaymentType.CASH) {
      this.exceptionSolutionService.showAlertWithSolution(`Devolución`, `El monto de la devolución sobrepasa el limite de efectivo ${returnMaxCash.value}`);
    }
    let confirmRresult = await this.confirmService.showAsync("Devolución de Factura", `¿Esta seguro de completar el proceso de devolucion para esta orden?`, ModalDialogType.SUCCESS);

    if (!confirmRresult) {
      return;
    }

    let transaction = new ReturnTransactionRequest();
    transaction.orderCode = this.order.code;
    transaction.branchCode = this.order.branchCode;
    transaction.salesOrgCode = this.order.salesOrgCode;
    transaction.registerCode = this.configService.readRegister().code;
    transaction.paymentType = type;
    transaction.contractRequestModels = [];
    transaction.invoiceDetails = this.order.orderEntryList.map(m => {
      let result = new InvoiceRequestModel();
      result.orderEntryCode = m.code;
      result.quantity = m.totalQuantity;
      return result;
    });
    transaction.voidOrderOperationType = this.route.snapshot.params.operation;
    let result = (await this.invoiceService.processReturnTransction(transaction).toPromise()).response.invoice;

    if (result.fullNumber) {
      Swal.fire({
        title: `Devolución`,
        html: `Se ha generado la nota de crédito ${result.fullNumber} con exito`,
        icon: 'success',
        confirmButtonText: 'Aceptar',
      });
      this.router.navigate(["returnInvoices", this.order.code], { queryParams: { print: true } });
    }
  }
}
